import { render, staticRenderFns } from "./comp_RecetaDigitalManager.vue?vue&type=template&id=5611c016&scoped=true&"
import script from "./comp_RecetaDigitalManager.vue?vue&type=script&lang=js&"
export * from "./comp_RecetaDigitalManager.vue?vue&type=script&lang=js&"
import style0 from "./comp_RecetaDigitalManager.vue?vue&type=style&index=0&id=5611c016&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5611c016",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VIcon,VProgressCircular,VSnackbar})
